import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, {HttpStatusCode} from "axios";
import { ApiUrlUtil } from "app/utils/apiUrlUtil";
import { HeadersUtil } from "app/utils/headersUtil";
import { ResponseApi, ResponseResultCode } from "app/model/response-api";
import { UserMenuModel } from "app/model/ua/user-menu";
import MenuUtil from "app/utils/menuUtil";

const initialState: any = {
  currentMenu: undefined,
  rootMenu: undefined,
  menus: [],
  flatMenus: [],
};

export const getUserMenus = createAsyncThunk("menu/userMenu", async (userId : string) => {
  let emksSysClCd = 1;
  const url = process.env.REACT_APP_URL_CO + "/menu/access";
  const param = { emksSysClCd: emksSysClCd };
  const response = await axios.get(ApiUrlUtil.buildQueryString(url, param), {
    headers: HeadersUtil.getHeadersAuth(),
  });

  if (response && "OK" === response.statusText) {
    // todo 디지털 에너지 인증 testintops 일때만 보이는 설정 추후 메뉴 확정 시 원복 필요 Line 40번쨰줄까지 삭제
    //  받아온 userId 또한 현재 상황에서만 필요한 정보이므로 추후 삭제 필요
    if(userId !== "testintops") {
      if(response.data && response.data.data && response.data.data.length > 0) {
        const flatMenu = MenuUtil.convertToFlatMenuArray(response?.data?.data);
        const newMenu = flatMenu.filter(d => d.menuUrlAddr !== "/el/board");

        return {
          statusCode: HttpStatusCode.Ok,
          resultCode: ResponseResultCode.Y,
          data: MenuUtil.convertToTreeMenuArray(newMenu),
        }
      } else {
        return response.data;
      }
    }
    return response.data;
  }
});

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setCurrentMenu: (state, action) => {
      state.currentMenu = action.payload.currentMenu;
      state.rootMenu = action.payload.rootMenu;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserMenus.pending, () => {})
      .addCase(getUserMenus.fulfilled, (state, action: any) => {
        const response = action.payload as ResponseApi<UserMenuModel[]>;
        if (response && ResponseResultCode.Y === response.resultCode) {
          state.menus = response.data;
          state.flatMenus = MenuUtil.convertToFlatMenuArray(response.data);
        }
      })
      .addCase(getUserMenus.rejected, (state) => {
        state.menus = [];
      });
  },
});

export default menuSlice.reducer;
export const { setCurrentMenu } = menuSlice.actions;